<template>
 <v-row>
      <v-col
        cols="12"
        lg="2"
      >
      <date-selector label="Fecha Inicio" ref="fecha_inicio"/>

    </v-col>    
    <v-col
        cols="12"
        lg="2"
      >
      <date-selector label="Fecha Fin" ref="fecha_fin"/>

    </v-col> 
    <v-col
        cols="12"
        lg="3"
      >
       <v-select
          v-model="alarma"
          :items="available_alarms"
          item-text="name"
          item-value="id"
         
          clearable
          label="Alarma"
          persistent-hint
          return-object
          single-line
        ></v-select>
    </v-col> 
     <v-col
        cols="12"
        lg="3"
      >

        <v-select
          v-model="seccion"
          :items="available_sections"
          clearable
          item-text="name"
          item-value="id"
          label="Sección"
          persistent-hint
          return-object
          single-line
        ></v-select>

    </v-col> 


    <v-col
        cols="12"
        lg="2"
      >
      <b-button @click="getData">Filtrar</b-button>

    </v-col>    
 
 </v-row>
</template>
<script>
import DateSelector from '../DateSelector.vue';

export default {
    components: { DateSelector },
    data() {
      return {
       alarma:null,
       seccion:null
      };
    },
    props: {
        available_alarms: [],
        available_sections: []
    },
    methods: {
        getData() {
            const payload = {
                'fecha_inicio':this.$refs.fecha_inicio.date,
                'fecha_fin':this.$refs.fecha_fin.date,
                'alarma':(this.alarma==null)?0:this.alarma,
                'seccion':(this.seccion==null)?0:this.seccion,               
            }
            this.$emit('getData',payload)
            
        }
    },
    

    
}
</script>
<style lang="">
    
</style>